import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

export const AccountSolarSettingsFragment = graphql(`
  fragment AccountSolarSettingsFields on AccountSolarSettings {
    retailTariffMinorPerKwh
    exportTariffMinorPerKwh
    defaultRetailTariffMinorPerKwh
    defaultExportTariffMinorPerKwh
    placementRules {
      edgeSetbackM
      columnGapM
      rowGapM
      excludeNorthFacing
      roofBearingWindowDeg {
        min
        max
      }
      singleIsland
      singleOrientation
      quadrilateralArrays
      flatRoof {
        maxSlopeDeg
        frameTiltDeg
        rowSpacingMultiplier
        rowSpacingMode
        fixedClearGapM
      }
      minPanelsPerRoof
      minSlopeDeg
      minSunAccessPercent
    }
    eess {
      selfConsumptionAllocationPercent
      defaultSelfConsumptionAllocationPercent
      thirdPartyControlTerms
      endOfLifeArrangements
      defaultEndOfLifeArrangements
    }
  }
`);

const GET_MY_ACCOUNT_SOLAR_SETTINGS = graphql(`
  query GetMyAccountSolarSettings {
    me {
      user {
        account {
          id
          solarSettings {
            ...AccountSolarSettingsFields
          }
        }
      }
    }
  }
`);

const useGetMyAccountSolarSettings = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.accountSolarSettings(),
    queryFn: () => gqlClient.request(GET_MY_ACCOUNT_SOLAR_SETTINGS),
  });

  return { solarSettings: data?.me.user.account.solarSettings, ...rest };
};

export default useGetMyAccountSolarSettings;
